<script>
	import TextInput from "../../../components/TextInput.svelte";
	import DeleteButton from "../../../components/buttons/DeleteButton.svelte";
	import AddButton from "../../../components/buttons/AddButton.svelte";

	// props
	export let employment = [];
	export let disabled = null;

	if (!employment || employment.length < 3) {
		employment = [
			...(employment || []),
			...Array(3 - (employment?.length || 0))
				.fill()
				.map(() => ({}))
		];
	}

	const deleteEmployment = (i) => {
		employment.splice(i, 1);
		employment = [...employment];
	};

	const addEmployment = () => {
		employment = [...employment, {}];
	};
</script>

<div class="wrapper">
	<table>
		<colgroup>
			<col style="width: 19%;" />
			<col style="width: 19%;" />
			<col style="width: 19%;" />
			<col style="width: 19%;" />
			<col style="width: 4%;" />
		</colgroup>
		<thead>
			<tr>
				<th>Place of Work</th>
				<th>Location of work</th>
				<th>When work was done</th>
				<th>Type of work performed</th>
				<th></th>
			</tr>
			<tr>
				<td>
					For example, the name of the station, mission, institution, settlement, or other. If you do not know
					the name, please provide as much information as possible about where you worked.
				</td>
				<td>
					For example, the town or area where the work was done. <br /><br />
				</td>
				<td>
					This can be the approximate year, range of years or decade.<br /><br />
				</td>
				<td>
					For example, station work, domestic work, other.<br /><br />
				</td>
				<td></td>
			</tr>
			<tr class="examples">
				<td class="examples">
					e.g. Wave Hill Station<br />
					e.g. Santa Teresa Mission<br />
					e.g. Warrabri Settlement
				</td>
				<td class="examples">
					e.g. Alice Springs<br />
					e.g. East Arnhem<br />
					e.g. Barkly Tableland
				</td>
				<td class="examples">
					e.g. 1955<br />
					e.g. 1955-1965<br />
					e.g. 1950's
				</td>
				<td class="examples">
					e.g. Station Work<br />
					e.g. Domestic Work<br />
					e.g. Cooking and cleaning
				</td>
				<td></td>
			</tr>
		</thead>
		<tbody>
			{#each employment as emp, i}
				<tr>
					<td>
						<TextInput bind:value={emp.placeOfWork} {disabled} placeholder="Type here" />
					</td>
					<td>
						<TextInput bind:value={emp.locationOfWork} {disabled} placeholder="Type here" />
					</td>
					<td>
						<TextInput bind:value={emp.whenWorkWasDone} {disabled} placeholder="Type here" />
					</td>
					<td>
						<TextInput bind:value={emp.typeOfWorkPerformed} {disabled} placeholder="Type here" />
					</td>
					<td>
						{#if employment.length > 1 && !disabled}
							<DeleteButton
								title="Remove this work place"
								on:delete={() => deleteEmployment(i)}
								{disabled}
							/>
						{/if}
					</td>
				</tr>
			{/each}
		</tbody>
	</table>
</div>

<div class="add confirmation-hide">
	<AddButton on:add={addEmployment} {disabled}>Add place of employment</AddButton>
</div>

<style>
	div.wrapper {
		margin-top: 36px;
		padding: 10px;
		background-color: #fff;
	}

	div.add {
		text-align: end;
		margin-top: 10px;
	}

	table {
		width: 100%;
		border-collapse: collapse;
	}

	thead td {
		font-size: 0.8rem;
		vertical-align: top;
	}

	th,
	td {
		padding: 8px;
	}

	th {
		padding: 0 8px;
	}

	td.examples {
		border-left-color: #fff;
		border-left-width: 8px;
		border-right-color: #fff;
		border-right-width: 8px;
		background-color: #dedede;
	}

	td.examples:first-child {
		border-left-width: 0;
	}

	td.examples:last-child {
		border-right-width: 0;
	}
</style>
